import { DeviceTypeProps } from "../models/CommonTypes";

import SentaraHealthPlansLogoImg from "../../assets/images/sentara_logo.svg";
import AvMedLogoImg from "../../assets/images/avmed_logo.svg";
import AvMedLogoImgV2 from "../../assets/images/avmed_logo_v2.svg";
import SentaraHealthPlansBannerImg from "../../assets/images/dashboard/banner_img.png";
import SentaraHealthPlansMobileImg from "../../assets/images/dashboard/banner_img_mob.png";
import AvMedBannerMobileImg from "../../assets/images/avmed_mobile_dashboard_bg.svg";
import AvmedBannerImg from "../../assets/images/AvMed_Hero_Dashboard.png";
import { t } from "i18next";
export const APPLICATION_TYPE = "EMPLOYER";

export const DeviceTypes = {
  DESKTOP: "desktop" as DeviceTypeProps,
  TABLET: "tablet" as DeviceTypeProps,
  MOBILE: "mobile" as DeviceTypeProps,
};

export const SERVICE_NUMBER = {
  GROUP_BUSINESS_NUMBER: "800-835-6131",
  INDIVIDUAL_MEDICARE_NUMBER: "800-461-2950",
  EMPLOYER_SERVICE_NUMBER: "(757) 552-8979",
  EMPLOYER_SERVICE_NUMBER_1: "(866) 296-7794",
  AVMedEMPLOYER_SERVICE_EMAIL: "Portal@sentara.com",
};

export const PAY_MONTHLY_INVOICE_INPUT_ERROR_TYPE = {
  INVALID_INPUT: "INVALID_INPUT",
  VALUE_LESS_THAN_0: "VALUE_LESS_THAN_0",
  VALUE_LESS_THAN_1: "VALUE_LESS_THAN_1",
  OVER_PAYMENT: "OVER_PAYMENT",
};

export const VALIDATION_LENGTH = {
  POLICY_ID_MAX_LENGTH: 12,
  MEMBER_ID_MAX_LENGTH: 20,
  SSN_MIN_LENGTH: 9,
  NAME_MAX_LENGTH: 20,
  ORGANIZATION_MAX_LENGTH: 200,
  EMAIL_MAX_LENGTH: 100,
  ADDRESS_MAX_LENGTH: 60,
  CITY_MAX_LENGTH: 40,
  POSTALCODE_MAX_LENGTH: 15,
  PHONENUMBER_MAX_LENGTH: 10,
  PASSWORD_MAX_LENGTH: 64,
  RENEWAL_DATE_MAX_LENGTH: 80,
  MEMBER_NUMBER_LENGTH: 6,
};

export const groupSizeItems = [
  {
    id: 1,
    value: "2-99",
  },
  {
    id: 2,
    value: "100+",
  },
];

export const LINK = {
  PRIVACY_POLICY_AVMED: "https://www.avmed.org/your-privacy",
  AGENTHOME_LINK: "",
  EMPLOYERHOME_LINK: "https://www.sentarahealthplans.com/employers",
  PRIVACY_POLICY:
    "https://www.sentarahealthplans.com/company/policies/privacy-statement",
  EMPLOYER_GROUP_REPORTING:
    "https://my.medeanalytics.com/fssologin.aspx?idp=Optimahealth&action=HandleIdpResponse",
  EMPLOYER_ENROLL_BENEFITS: "https://sentarahealth.my.site.com/benefit/",
  FREQUENTLY_ASKED_QUESTION:
    "https://www.sentarahealthplans.com/employers/frequently-asked-questions",
  EMPLOYER_BILLING_STATEMENT: "https://reports.sentarahealthplans.com/r2w/",
  LEARN_MORE_LINK_DASHBOARD:
    "https://www.sentarahealthplans.com/employers/updates",
  LEARN_MORE_LINK_DASHBOARD_AVMED:
    "https://www.avmed.org/news/publications/employer/",
  PAY_MONTHLY_STATEMENT:
    "https://sts.sentara.com/adfs/ls/idpinitiatedSignOn.aspx?loginToRp=demo.e-billexpress.com",
  PAY_MONTHLY_STATEMENT_PROD:
    "https://sts.sentara.com/adfs/ls/idpinitiatedSignOn.aspx?loginToRp=e-billexpress.com",
  LEARN_MORE_LINK_DASHBOARD_BRAND: "https://www.avmed.org/news/",
  CONTACT_US_DASHBOARD:
    "https://www.sentarahealthplans.com/employers/contact-us",
  CONTACT_US_DASHBOARD_BRAND:
    "https://www.avmed.org/contact-us/#8775bdaf-6d43-4eea-9fa3-7da13689d929",
};

export const IDLETIMER = {
  delay: 840 * 1000,
  timeout: 60000,
};
export const listPerTable = 10;

export const BrandLogoImages = {
  shp: SentaraHealthPlansLogoImg,
  avmed: AvMedLogoImg,
  avmed_v2: AvMedLogoImgV2,
};
export const EmployerMasterCarrierId = {
  shp: 1,
  avmed: 2,
};
export const BrandBannerImages = {
  shp: SentaraHealthPlansBannerImg,
  shp_mobile: SentaraHealthPlansMobileImg,
  avmed: AvmedBannerImg,
  avmed_mobile: AvMedBannerMobileImg,
  shpBackgroundColor: "#22706614",
  avmedBackgroundColor: "",
  shpBackgroundSize: "contain",
  avmedBackgroundSize: "100%",
};

export const BrandBannerTitle = {
  shp: t("dashboard.label.title"),
  avmed: t("dashboard.label.title"),
};

export const BrandBannerDesc = {
  shp: t("dashboard.label.bannerDesc"),
  avmed: t("dashboard.label.bannerDesc"),
};

export const BrandBannerButtonText = {
  shp: t("dashboard.label.learnMore"),
  avmed: t("dashboard.label.learnMore"),
};

export const subscriberMinLength = 6;

export const MemberRelationship = {
  D: "Dependent",
  P: "Subscriber",
  S: "Spouse",
};

export const MEMBERSTATUS = {
  E: "Enrolled",
  D: "Disenrolled",
};

// Employer Relationship Code = 3
export const EMPLOYER_RELATIONSHIP_CODE = 3;

// Dashboard Tiles
export const TilesIds = {
  Title1: "tile1",
  Title2: "tile2",
  Title3: "tile3",
  Title4: "tile4",
  Title5: "tile5",
  Title6: "tile6",
  Title7: "tile7",
};
